import * as React from "react";

import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";

import NotesIcon from "@mui/icons-material/Notes";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";
import FormatColorFillIcon from "@mui/icons-material/FormatColorFill";

import { NOT_PROVIDED } from "../common/sudCard";

const SudMoreInfoList = ({
  designStandard,
  notes,
  catchmentArea,
  storageVolume,
}) => {
  return (
    <List dense disablePadding>
      <ListItem disablePadding dense>
        <ListItemIcon>
          <NotesIcon />
        </ListItemIcon>
        <ListItemText
          primary="Public Notes"
          secondary={notes || NOT_PROVIDED}
          sx={{ mb: 0 }}
        />
      </ListItem>
      <ListItem disablePadding dense>
        <ListItemIcon>
          <DesignServicesIcon />
        </ListItemIcon>
        <ListItemText
          primary="Design Standard"
          secondary={designStandard || NOT_PROVIDED}
          sx={{ mb: 0 }}
        />
      </ListItem>

      <ListItem disablePadding dense>
        <ListItemIcon>
          <MapsHomeWorkIcon />
        </ListItemIcon>
        <ListItemText
          primary="Catchment Area"
          secondary={catchmentArea || NOT_PROVIDED}
          sx={{ mb: 0 }}
        />
      </ListItem>

      <ListItem disablePadding dense>
        <ListItemIcon>
          <FormatColorFillIcon />
        </ListItemIcon>
        <ListItemText
          primary="Storage Volume"
          secondary={storageVolume || NOT_PROVIDED}
          sx={{ mb: 0 }}
        />
      </ListItem>
    </List>
  );
};

export default SudMoreInfoList;
